import { STATUS_META } from "@/lib/api";

export default function StatusBadge({ status, size = "sm" }) {
  const meta = STATUS_META[status] || STATUS_META.unassigned;
  const padding = size === "lg" ? "px-3 py-1" : "px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${padding} text-xs font-medium ${meta.bg} ${meta.text}`}
      data-testid={`status-${status}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
}
